/* eslint-disable no-unused-vars */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import 'font-awesome/css/font-awesome.css';
import { fetchLocales, changeLanguage } from 'actions/changeLanguageActions';
import { ENGLISH, JAPANESE } from 'constants/language';
import { store, getBrowserLanguage } from './utils';
import App from './components/App';
import './styles/styles.scss';
import './favicons/manifest.json';
import './favicons/favicon-16x16.png';
import './favicons/favicon-32x32.png';
import './favicons/favicon.ico';
import './favicons/android-chrome-192x192.png';
import './favicons/apple-touch-icon.png';
import './i18n';
import pkgJson from '../package.json';

window._att_version = {
    ...window._att_version,
    [pkgJson.name]: process.env.GITHUB_SHA
};

const initiateApp = () => {
    store.dispatch(changeLanguage(getBrowserLanguage() === JAPANESE ? JAPANESE : ENGLISH));
    store.dispatch(fetchLocales());
    render(
        <Provider store={ store }>
            <App />
        </Provider>, document.getElementById('app')
    );
};

if (window.location.pathname !== '/errorpage.html') {
    initiateApp();
}
